import './index.css';
import { closeIcon, imageIcon, micIcon } from '../../assets';
import { TextProfileIcon } from '../TextProfileIcon';
import { MessageInput } from '../MessageInput';
import SocketStore from '../../stores/SocketStore';
import ChatStore from '../../stores/ChatStore';
import { observer } from 'mobx-react';
import { useEffect, useRef } from 'react';
import strings from '../../localization';
import MainStore from '../../stores/MainStore';
import { formatDateTime } from '../../helpers/functions';

const TypingIndicator = (name) => {
  return (
    <div key={'typing-indicator'} className={`call-chat-message call-chat-message-tech`}>
      <TextProfileIcon text={name} isOnline={true} />
      <span>{strings.typing}</span>
    </div>
  );
}

const CustomerCallChat = ({ handleChatIsOpen }) => {

  const messagesListRef = useRef(null);

  const sendMessage = (message) => {
    SocketStore.sendCustomerMessage({
      type: 'text',
      content: message
    });
  }

  useEffect(() => {
    setTimeout(() => {
      if (messagesListRef.current) {
        messagesListRef.current.scrollTo({
          top: messagesListRef.current.scrollHeight,
          behavior: 'smooth'
        });
      }
    }, 100);
  }, [ChatStore.messages.length]);


  return (
    <div className="customer-call-chat">
      <div className="customer-call-chat-inner">
        <button className="customer-call-chat-close" onClick={() => {
          handleChatIsOpen();
        }}>
          <img src={closeIcon} alt="close" />
        </button>

        <div className="customer-call-chat-messages" ref={messagesListRef}>
          {ChatStore.messages.length > 0 && ChatStore.messages.map((message) => {

            const date = formatDateTime(message.timestamp ? message.timestamp : message.createdAt);

            return (
              <div key={message.id} className={`call-chat-message ${message.from === 'customer' ? 'call-chat-message-user' : 'call-chat-message-tech'}`}>
                <div className='call-chat-message-inner'>
                  <TextProfileIcon text={message.from} isOnline={message.from === 'tech'} />
                  {message.message.type === 'text' && <span className='call-chat-message-text'>{message.message.content}</span>}
                  {message.message.type === 'file' && <div className='tech-call-chat-message-file-container'>
                    <img
                      onClick={() => MainStore.setImageModalData(message.message.content)}
                      src={message.message.content.presignedUrl} alt="image" className='customer-call-chat-message-file-image' />
                  </div>}
                </div>
                {date && <span className='call-chat-message-date'>{date}</span>}
              </div>
            )
          })}
          {ChatStore.isTyping && TypingIndicator('technician')}
        </div>

      </div>
      <div className="customer-call-chat-container-bottom">
        <MessageInput size="small" onSend={sendMessage} role="customer" />
        {/* <div className="customer-call-chat-container-bottom-buttons">
          <button className="button-round button-round-small">
            <img src={imageIcon} alt="image" />
          </button>
        </div> */}
      </div>
    </div >
  );
};

export default observer(CustomerCallChat);